import { useMemo } from 'react';
import { assertCondition } from '../../../utils/types';
import { QueryType } from '../../../utils/apollo/graphqlSchema';
import { IReportBuilderInfoProps } from '../types';
import CohortSampleContent from './CohortSampleContent';
import ReportInfo from './ReportInfo';
import PathInfoContent from './PathInfoContent';
import SignificanceBuilderContent from './SignificanceBuilderContent';
import { reportInformationIconViewed } from '../../../utils/analytics/events/report/events';
import { useAnalyticsEffect } from '../../../utils/analytics/useAnalyticsEffect';
import { useAppSelector } from '../../../redux/hooks';
import { analysisSelector } from '../../../redux/selectors/analyses';

export default (props: IReportBuilderInfoProps) => {
  const { analysisId, onShowInReport, queryType } = props;

  const analysisMemoizedSelector = useMemo(analysisSelector, []);
  const analysis = useAppSelector((state) =>
    analysisMemoizedSelector(state, analysisId),
  );
  useAnalyticsEffect((track) => {
    if (analysis?.builderInfo) {
      track(reportInformationIconViewed(analysis.builderInfo));
    }
  });

  assertCondition(
    queryType !== QueryType.Prediction,
    `There is no BuilderInfo component for ${queryType}`,
  );

  if (queryType === QueryType.CohortSample) {
    return (
      <CohortSampleContent
        analysisId={analysisId}
        onShowInReport={onShowInReport}
      />
    );
  }

  if (queryType === QueryType.Path) {
    return (
      <PathInfoContent
        analysisId={analysisId}
        onShowInReport={onShowInReport}
      />
    );
  }

  if (queryType === QueryType.Significance) {
    return (
      <SignificanceBuilderContent
        analysisId={analysisId}
        onShowInReport={onShowInReport}
      />
    );
  }

  return <ReportInfo {...props} />;
};
